<template>
  <div class="popup_in">
    <div class="popup" style="max-width:550px;" v-click-outside="clickOutside">
      <div class="popup_close popup_close-25 close-animate">
        <a href="javascript:void(0);" @click="$emit('close')"><CloseBlue /></a>
      </div>
      <div class="popup-content">
        <div class="title--32 tx--blue2">{{ title }}</div>
        <div class="content">
          <div v-if="!files.length" class="center">
            <img class="" src="/assets/img/svg/loader-blue.svg" />
          </div>
          <div v-else>
            <a
              v-for="(file, i) in files"
              :key="i"
              class="table-file flex"
              href="javascript:void(0)"
              @click="downloadFile(file)"
              :style="file.path ? 'cursor: pointer' : 'cursor: default'"
            >
              <img class="svg" src="/assets/img/svg/ic-file.svg" />
              <span class="is--fit tx_file text--right">{{ file.name }}</span>
              <span v-show="file.path" class="files-overlay-show tx-blue"
                >הצג</span
              >
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Error from "../Popups/Error.vue";
import CloseBlue from "../../assets/img/svg/close-blue.svg";
import ClickOutside from "vue-click-outside";
import { downloadDocument } from "../../utilities/download-document";

export default {
  props: {
    tableType: { required: true },
    eventId: { required: true },
    propsFiles: { default: () => [] }
  },
  data() {
    return {
      files: []
    };
  },
  async created() {
    if (this.propsFiles.length) {
      this.files = this.propsFiles;
      return;
    }
    this.getFiles();
  },
  computed: {
    title() {
      if (this.tableType === "ivf") return "מסמכי תוכניות טיפול IVF";
      return "מסמכים מצורפים למטופל";
    }
  },
  methods: {
    /**
     * Getting all the files from the event.
     * Converting the response to array of
     * objects the HTML and downloadFile()
     * can handle.
     */
    async getFiles() {
      try {
        if (this.tableType == "appointment") {
          /// Get appointment documents
          const response = await this.$API.getAppointmentInfo(this.eventId);
          if (response.status !== "OK") throw "";
          this.files = response.message.documents;
          return;
        }
        /// Get surgery documents
        const response = await this.$API.getSurgeryDocuments(this.eventId);
        if (response.status !== 200) throw "";
        this.files = response.data.data.map(d => ({
          id: d.id,
          name: d.file.file_name,
          path:
            "https://md-booking.hmc.co.il/ex-doctor/external" +
            d.file.full_path,
          type: d.type
        }));
      } catch (error) {
        console.log(error);
        this.$modal.show(Error, {
          title: "התרחשה שגיאה, אנא נסו שנית מאוחר יותר"
        });
      }
    },
    /**
     * @param {Object} file object that created
     * in getFiles() function.
     */
    async downloadFile(file) {
      if (!file.path) return;
      try {
        this.$emit("toggleIsFilesOverlayOpen", false);
        await downloadDocument(file.path, file.name);
      } catch (error) {
        this.$modal.show(Error, {
          title: "התרחשה שגיאה, אנא נסו שנית מאוחר יותר"
        });
      }
    },
    /**
     * Click outside of the popup.
     */
    clickOutside() {
      this.$emit("close");
    }
  },
  components: {
    CloseBlue
  },
  directives: {
    ClickOutside
  }
};
</script>
